import { Text } from '@components/v2/ui';
import { TOffset } from '@global-types/api/api';
import {
	Anchor,
	Box,
	Flex,
	NumberInput,
	Stack,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './AdditionalitiesOffsetSummaryCart.module.css';

type TAdditionalitiesOffsetCardProps = {
	contribution?: TOffset;
	onPriceChange: (newPrice: number) => void;
	onRemove: (id: string) => void;
	name: string;
	price: number | undefined;
};

export const AdditionalitiesOffsetCard: React.FC<
	TAdditionalitiesOffsetCardProps
> = ({ name, onPriceChange, onRemove, price }) => {
	const { t } = useTranslation();
	return (
		<Box
			className={
				classes.containerAdditionalitiesOffsetCard
			}
		>
			<Text
				variant="caption"
				c="var(--mantine-color-igluTextSecondary-9)"
			>
				{t('global.amountInEuro')}
			</Text>
			<Flex
				justify={'space-between'}
				gap={'14px'}
				w={'100%'}
			>
				<Stack gap={'0px'}>
					<Text
						variant="subtitle1"
						c="var(--mantine-color-igluTextPrimary-9)"
					>
						{name}
					</Text>
				</Stack>
				<NumberInput
					placeholder={'0'}
					w={90}
					miw={90}
					radius={'25px'}
					value={price ?? 0}
					onChange={(value) => {
						onPriceChange(Number(value));
					}}
				/>
			</Flex>
			<Flex w={'100%'} align={'center'}>
				<Anchor
					onClick={() => {
						onRemove('offsetId');
					}}
					underline="always"
					c={'var(--mantine-color-igluRed-9)'}
				>
					{t('global.delete')}
				</Anchor>
			</Flex>
		</Box>
	);
};
